const fillServerErrors = require('../../../common/components/servererrorfiller');

function ResetController($scope, globalHeaderPanelService, resetPasswordService, settingsService, breakpointsService, moveFocus) {
    this.resetPasswordService = resetPasswordService;
    this.globalHeaderPanelService = globalHeaderPanelService;
    this.breakpointService = breakpointsService;
    this.moveFocus = moveFocus;
    this.emailInput = this.emailAddress;
    this.loading = false;

    // Move focus to reset email input when view has loaded
    moveFocus('#resetForm-email');

    settingsService.getSettingValue('PasswordReminder', 'PasswordReminderContactUsLink').then(function (value) {
        this.contactUsLink = value;
    }.bind(this));

    $scope.$on('headerPanel:close', function (event, panelName) {
        if (panelName === globalHeaderPanelService.panels.login) {
            moveFocus('#loginPanel-toggleButton');
        }
    });
}

function validateResetPasswordEmail(resetForm, email) {
    if (email != null && email.trim() !== '') {
        return true;
    }
    resetForm.email.$setValidity('required', false);
    resetForm.email.$setTouched();
    return false;
}

ResetController.prototype.sendResetRequest = function () {
    fillServerErrors.clearForm(this.resetForm, this);
    const self = this;

    if (!this.resetForm.$valid || !validateResetPasswordEmail(this.resetForm, this.emailInput)) {
        // don't submit to server if client side is not valid
        this.hasSubmittedForm = false;
        return;
    }
    this.loading = true;

    this.resetPasswordService.forgotPassword(this.emailInput).then(
        function (response) {
            self.loading = false;
            if (response.Success) {
                self.resetSuccess = true;
            }
        },
        function (response) {
            fillServerErrors.fillForm(self.resetForm, response.data.ResponseStatus.Errors, self);
            self.loading = false;
            self.resetSuccess = false;
        }
    );
    this.hasSubmittedForm = true;
};

ResetController.prototype.cancelReset = function () {
    if (this.globalHeaderPanelService._openPanel !== 'none') {
        this.globalHeaderPanelService.openPanel(this.globalHeaderPanelService.panels.login);
    } else {
        window.history.back();
    }
};

ResetController.prototype.closeResetPasswordForSF = function () {
    if (this.showResetPassword) {
        this.showResetPassword = false;
    }
};

ResetController.prototype.closeLoginPrompt = function () {
    if (this.breakpointService.isInSmallFormat) {
        this.closeResetPasswordForSF();
    }

    if (this.onClose) {
        this.onClose();
    }
};

function resetDirectiveFactory() {
    return {
        restrict: 'E',
        scope: {
            onClose: '&?',
            emailAddress: '@'
        },
        controller: ['$scope', 'GlobalHeaderPanelService', 'ResetPasswordService', 'SettingsService', 'BreakpointsService', 'MoveFocus', ResetController],
        controllerAs: 'ctrl',
        bindToController: true,
        template: require('./login-password-reset-template.html').trim()
    };
}

module.exports = {
    DirectiveController: ResetController,
    directiveFactory: resetDirectiveFactory
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-password-reset-directive.js
 **/